import type { ReactNode } from 'react';
import { cx } from '../../../utils/cx';
import styles from './FormControls.module.scss';

interface FieldRowProps {
  /** single — поля в один столбец, pair — два равных столбца. */
  layout?: 'pair' | 'single';
  children: ReactNode;
}

export function FieldRow({ layout = 'pair', children }: FieldRowProps) {
  return <div className={cx(styles.row, layout === 'single' && styles.rowSingle)}>{children}</div>;
}
